import React, { useState, useEffect, useCallback, useMemo } from "react";
import {
  Card,
  CardContent,
  Typography,
  Grid2,
  Box,
  Divider,
  Chip,
  List,
  ListItem,
  Avatar,
  Tab,
  Tabs,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  Tooltip,
} from "@mui/material";
import { format } from "date-fns";
import { useNavigate } from "react-router-dom";
import {
  obtnerCambioEnOrden,
  registrarCambioEnOrden,
} from "../../redux/accionsRegister";
import { useDispatch, useSelector } from "react-redux";
import { collection, doc, updateDoc } from "firebase/firestore";
import { GeoPoint } from "firebase/firestore";
import { db } from "../../firebase";
import { translateStatesfalabbela } from "../../utils/objects/translateStates";
import CreateEmailClientForm from "./FormsEdithOrders/CreateEmailClientForm";
import CreateEmailSecondAttemptForm from "./FormsEdithOrders/CreateEmailSecondAttemptForm";
import CreateEmailThirdAttemptForm from "./FormsEdithOrders/CreateEmailThirdAttemptForm";
import CreateEmailConfirmationForm from "./FormsEdithOrders/CreateEmailConfirmationForm";
import CreateEmailAuthorizationForm from "./FormsEdithOrders/CreateEmailAuthorizationForm";
import AdjustGeoReferenceForm from "./FormsEdithOrders/AdjustGeoReferenceForm";
import AddNewAddressForm from "./FormsEdithOrders/AddNewAddressForm";
import TicketSupportForm from "./FormsEdithOrders/TicketSupportForm";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ZoomInIcon from "@mui/icons-material/ZoomIn";
import ZoomOutIcon from "@mui/icons-material/ZoomOut";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import CloseIcon from "@mui/icons-material/Close";
import DownloadIcon from "@mui/icons-material/Download";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { Button, Snackbar, Alert } from "@mui/material";

var data = "Sin contenido";
var dataContenido = "No se muestran datos";
var dataDriver = "No se muestran datos";
var actionsOrders = "no se muestran datos";
var logDeCambios = "no se muestran datos";

const TabSecondary = ({
  orderDetails,
  orderDetailsCliente,
  dataOrdesBicciExpress,
  usuarioStorage,
  bloqueaGoogle,
  setOrderDetails,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const storePayload = useSelector((store) => store.accionsRegisterLogs);
  const [foto, setFoto] = useState([]);
  const [date, setDate] = useState([]);
  const [comment, setComment] = useState("");
  const [picsTaken, setPicsTaken] = useState(false);
  const [confirmDireccion, setConfirmDireccion] = useState("");
  const [newLocation, setNewLocation] = useState(null);
  const [activeTab, setActiveTab] = useState(0);
  const [copyOpen, setCopyOpen] = React.useState(false);
  const [copyMsg, setCopyMsg] = React.useState("");
  const collectionRef = collection(
    db,
    `${process.env.REACT_APP_COL_USERS_ORDERS}`
  );

  useEffect(() => {}, [foto, newLocation]);

  useEffect(() => {
    if (orderDetails.pics) {
      var arraysPics = [];
      for (let i = 0; i < orderDetails.pics.length; i++) {
        arraysPics.push(orderDetails.pics[i]);
      }
      setFoto(arraysPics);
    }
    if (
      orderDetails.deliveryPictures &&
      orderDetails.deliveryPictures !== "isRequire"
    ) {
      var arraysPics = [];

      arraysPics.push(orderDetails.deliveryPictures);

      setFoto(arraysPics);
      setPicsTaken(arraysPics.length > 0 ? true : false);
    }

    if (
      orderDetails &&
      orderDetails.date &&
      orderDetailsCliente &&
      orderDetailsCliente.updatedAt
    ) {
      setDate(
        format(
          orderDetailsCliente.updatedAt.seconds * 1000,
          "dd/MM/yy HH:mm:ss"
        ).toString()
      );
    }
    if (orderDetails.id) {
      dispatch(obtnerCambioEnOrden(orderDetails.id));
    }
  }, [orderDetails && orderDetailsCliente]);

  const handleChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const handleCopyDeliveryLine = async () => {
    const isDelivered = Number(orderDetails?.status) === 8;

    const fechaEntrega = date || "No disponible"; // usa tu variable `date`
    const nombre =
      orderDetails?.userNameReceptor ||
      orderDetails?.deliveryReceptor ||
      "No disponible";

    const rut =
      orderDetails?.userDniReceptor ||
      orderDetails?.deliveryRut ||
      "No disponible";

    const line = `${isDelivered ? "Entregado" : "No entregado"}  ${
      orderDetails.id
    } | Última actualización: ${fechaEntrega} | Fecha de entrega: ${fechaEntrega} | Nombre: ${nombre} | RUT: ${rut}`;

    try {
      await navigator.clipboard.writeText(line);
      setCopyMsg("Copiado ✅");
      setCopyOpen(true);
    } catch (e) {
      // Fallback por si el navegador bloquea clipboard
      const ta = document.createElement("textarea");
      ta.value = line;
      document.body.appendChild(ta);
      ta.select();
      document.execCommand("copy");
      document.body.removeChild(ta);

      setCopyMsg("Copiado ✅");
      setCopyOpen(true);
    }
  };
  {
    /* ====== LIGHTBOX / CARRUSEL ====== */
  }
  {
    /** Estado local (puede ir al inicio del componente padre si prefieres) */
  }
  {
    /* eslint-disable-next-line react-hooks/rules-of-hooks */
  }
  const [lightbox, setLightbox] = useState({ open: false, index: 0 });
  {
    /* eslint-disable-next-line react-hooks/rules-of-hooks */
  }
  const [zoom, setZoom] = useState(1);
  {
    /* eslint-disable-next-line react-hooks/rules-of-hooks */
  }
  const [offset, setOffset] = useState({ x: 0, y: 0 });
  {
    /* eslint-disable-next-line react-hooks/rules-of-hooks */
  }
  const [drag, setDrag] = useState({
    active: false,
    startX: 0,
    startY: 0,
    baseX: 0,
    baseY: 0,
  });

  // Helpers
  const currentSrc = useMemo(
    () => foto[lightbox.index] ?? "",
    [foto, lightbox.index]
  );
  const next = useCallback(
    () => setLightbox((s) => ({ ...s, index: (s.index + 1) % foto.length })),
    [foto.length]
  );
  const prev = useCallback(
    () =>
      setLightbox((s) => ({
        ...s,
        index: (s.index - 1 + foto.length) % foto.length,
      })),
    [foto.length]
  );
  const resetView = useCallback(() => {
    setZoom(1);
    setOffset({ x: 0, y: 0 });
  }, []);
  const zoomIn = useCallback(() => setZoom((z) => Math.min(z + 0.25, 5)), []);
  const zoomOut = useCallback(() => setZoom((z) => Math.max(z - 0.25, 1)), []);
  const onWheel = useCallback((e) => {
    e.preventDefault();
    if (e.deltaY < 0) setZoom((z) => Math.min(z + 0.25, 5));
    else setZoom((z) => Math.max(z - 0.25, 1));
  }, []);

  // Arrastre para pan
  const onMouseDown = (e) => {
    if (zoom === 1) return;
    setDrag({
      active: true,
      startX: e.clientX,
      startY: e.clientY,
      baseX: offset.x,
      baseY: offset.y,
    });
  };
  const onMouseMove = (e) => {
    if (!drag.active) return;
    const dx = e.clientX - drag.startX;
    const dy = e.clientY - drag.startY;
    setOffset({ x: drag.baseX + dx, y: drag.baseY + dy });
  };
  const endDrag = () => setDrag((d) => ({ ...d, active: false }));

  // Teclado: flechas para navegar, ESC para cerrar
  useEffect(() => {
    if (!lightbox.open) return;
    const handler = (e) => {
      if (e.key === "ArrowRight") next();
      else if (e.key === "ArrowLeft") prev();
      else if (e.key === "Escape") setLightbox({ open: false, index: 0 });
    };
    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, [lightbox.open, next, prev]);

  const panes = [
    { label: "Datos de Orden", content: data },
    { label: "Contenido de Orden", content: dataContenido },
    { label: "Datos de Driver", content: dataDriver },
    { label: "Acciones", content: actionsOrders },
    { label: "Registro de Acciones", content: logDeCambios },
  ];

  function formatPhone(phone) {
    if (!phone) return "";
    const clean = phone.replace(/\D/g, ""); // quita no numéricos
    if (clean.length === 8) {
      // Ejemplo: 87654321
      return `+56 9 ${clean.slice(0, 4)} ${clean.slice(4)}`;
    }
    if (clean.length === 9 && clean.startsWith("9")) {
      // Ejemplo: 987654321
      return `+56 9 ${clean.slice(1, 5)} ${clean.slice(5)}`;
    }
    return `+56 9 ${clean}`;
  }

  const getStatusColor = (status) => {
    switch (status) {
      case "Entregado":
      case "Finalizado":
        return "success";
      case "En Proceso":
      case "En ruta":
        return "warning";
      case "Pendiente":
      case "Requiere Actualización":
        return "error";
      default:
        return "default";
    }
  };

  const addNewGeoPoint = async (newLocation) => {
    let newGeo = new GeoPoint(
      parseFloat(newLocation.lat),
      parseFloat(newLocation.lng)
    );
    let data = {
      date: new Date(),
      lastValue: orderDetails.toAddressLocation,
      newValue: newGeo,
      orderId: orderDetails.id,
      type: "infoAdd",
      userId: usuarioStorage.uid,
      var: "toAddressLocation",
    };

    dispatch(registrarCambioEnOrden(data));

    const orderRef1 = doc(collectionRef, `${orderDetails.id}`);
    try {
      await updateDoc(orderRef1, {
        toAddressLocation: newGeo,
      });

      setOrderDetails((prev) => ({
        ...prev,
        toAddressLocation: newGeo,
      }));
    } catch (error) {}

    setNewLocation(null);
  };

  const createEmailclient = (e) => {
    e.preventDefault();
    const uniqueId = e.target.elements.uniqueId.value;

    let data = {
      date: new Date(),
      lastValue: "0",
      newValue: "send",
      orderId: orderDetails.id,
      type: uniqueId,
      userId: usuarioStorage.uid,
      var: "email",
    };

    dispatch(registrarCambioEnOrden(data));

    const propsData = {
      acction: uniqueId,
      dirección: confirmDireccion,
      data: orderDetails,
      data2: orderDetailsCliente,
      data3: dataOrdesBicciExpress || [],
    };
    navigate(`/dashboard/dispatch/details/${orderDetails.id}/prewiew_email`, {
      state: propsData,
    });
  };

  const createTicketSuport = (e) => {
    e.preventDefault();
    let data = {
      date: new Date(),
      lastValue: "0",
      newValue: comment,
      orderId: orderDetails.id,
      type: "ticket",
      userId: usuarioStorage.uid,
      var: "ticket",
    };

    dispatch(registrarCambioEnOrden(data));
  };

  data = (
    <Box sx={{ p: 0, m: 0, textAlign: "left" }}>
      {/* ====== ARRIBA: 3 secciones (Origen | Destino | Datos adicionales) ====== */}
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: {
            xs: "1fr",
            md: "repeat(3, minmax(0, 1fr))", // <- columnas idénticas
          },
          gap: 3,
          alignItems: "space-between",
        }}
      >
        {/* Origen */}
        <Grid2 xs={12} md={12} lg={4}>
          <Box
            sx={{
              p: 1,
              borderRadius: 2,
              border: "1px solid",
              borderColor: "divider",
              bgcolor: "background.paper",
              boxShadow: "0 1px 6px rgba(0,0,0,0.04)",
              height: "100%",
              display: "flex",
              flexDirection: "column", // <- clave
              minHeight: { md: 320 },
            }}
          >
            <Typography
              variant="h6"
              fontWeight={700}
              color="primary"
              gutterBottom
            >
              Datos Origen
            </Typography>
            <Divider sx={{ mb: 2 }} />

            <Box sx={{ display: "grid", rowGap: 1.25 }}>
              <Grid2 xs={12}>
                <Typography variant="subtitle2" fontWeight="bold">
                  Nombre de Usuario:
                </Typography>
                <Typography variant="body2">
                  {orderDetails.placeName ||
                    orderDetails.commerce ||
                    "No disponible"}
                </Typography>
              </Grid2>

              <Grid2 xs={12}>
                <Typography variant="subtitle2" fontWeight="bold">
                  Dirección:
                </Typography>
                <Typography variant="body2">
                  {orderDetails.fromAddress &&
                  orderDetails.fromAddress !== "isRequire"
                    ? orderDetails.fromAddress
                    : orderDetails.int_warehouseName || "No disponible"}
                </Typography>
              </Grid2>
            </Box>
          </Box>
        </Grid2>

        {/* Destino */}
        <Grid2 xs={12} md={12} lg={4}>
          <Box
            sx={{
              p: 1,
              borderRadius: 2,
              border: "1px solid",
              borderColor: "divider",
              bgcolor: "background.paper",
              boxShadow: "0 1px 6px rgba(0,0,0,0.04)",
              height: "100%",
              display: "flex",
              flexDirection: "column", // <- clave
              minHeight: { md: 320 },
            }}
          >
            <Typography
              variant="h6"
              fontWeight={700}
              color="primary"
              gutterBottom
            >
              Datos Destino
            </Typography>
            <Divider sx={{ mb: 2 }} />

            <Grid2 xs={12}>
              <Typography variant="subtitle2" fontWeight="bold">
                Nombre:
              </Typography>
              <Typography
                variant="body2"
                sx={{ fontSize: "1.2rem", fontWeight: "bold" }}
              >
                {orderDetails.userName && orderDetails.userName !== "isRequire"
                  ? orderDetails.userName
                  : orderDetails.clientNames || "No disponible"}
              </Typography>
            </Grid2>

            <Grid2 xs={12}>
              <Typography variant="subtitle2" fontWeight="bold">
                Destino:
              </Typography>
              <Typography variant="body2" sx={{ fontWeight: "bold" }}>
                {orderDetails.toAddress || "No disponible"}
              </Typography>
            </Grid2>

            <Grid2 xs={12}>
              <Typography variant="subtitle2" fontWeight="bold">
                Email Cliente:
              </Typography>
              <Typography variant="body2">
                {orderDetails.userEmail &&
                orderDetails.userEmail !== "isRequire"
                  ? orderDetails.userEmail
                  : orderDetails.clientEmail || "No disponible"}
              </Typography>
            </Grid2>

            <Grid2 xs={12}>
              <Typography variant="subtitle2" fontWeight="bold">
                Teléfono:
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  flexWrap: "wrap",
                }}
              >
                <span style={{ fontSize: "1.2em", fontWeight: "bold" }}>
                  {formatPhone(orderDetails.userPhone)} |
                </span>
                <a
                  href={`callto:+569${orderDetails.userPhone}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Llamar
                </a>
              </Typography>
            </Grid2>

            <Grid2 xs={12}>
              <Typography variant="subtitle2" fontWeight="bold">
                Localidad:
              </Typography>
              <Typography variant="body2">
                {String(
                  orderDetailsCliente?.commune1 ??
                    orderDetails.commune2 ??
                    "No disponible"
                )}
              </Typography>
            </Grid2>

            <Grid2 xs={12}>
              <Typography variant="subtitle2" fontWeight="bold">
                Locación destino:
              </Typography>
              <Typography variant="body2">
                {orderDetails.toAddressLocation ? (
                  <a
                    href={`https://www.google.com/maps/search/?api=1&query=${
                      orderDetails.toAddressLocation.latitude ||
                      orderDetails.toAddressLocation.lat
                    },${
                      orderDetails.toAddressLocation.longitude ||
                      orderDetails.toAddressLocation.lng
                    }`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Ver en mapa
                  </a>
                ) : (
                  "No disponible"
                )}
              </Typography>
            </Grid2>
          </Box>
        </Grid2>

        {/* Datos Adicionales */}
        <Grid2 xs={12} md={12} lg={4}>
          <Box
            sx={{
              p: 1,
              borderRadius: 2,
              border: "1px solid",
              borderColor: "divider",
              bgcolor: "background.paper",
              boxShadow: "0 1px 6px rgba(0,0,0,0.04)",
              height: "100%",
              display: "flex",
              flexDirection: "column",
              minHeight: { md: 320 },
            }}
          >
            <Typography
              variant="h6"
              fontWeight={700}
              color="primary"
              gutterBottom
            >
              Datos Adicionales
            </Typography>
            <Divider sx={{ mb: 2 }} />

            <Grid2 xs={12}>
              <Typography variant="subtitle2" fontWeight="bold">
                SOC:
              </Typography>
              <Typography variant="body2">
                {orderDetailsCliente?.soc ||
                  orderDetails.orderID ||
                  "No disponible"}
              </Typography>
            </Grid2>

            <Grid2 xs={12}>
              <Typography variant="subtitle2" fontWeight="bold">
                F12:
              </Typography>
              <Typography variant="body2">
                {dataOrdesBicciExpress?.[0]?.F12 ||
                  dataOrdesBicciExpress?.[0]?.int_f12 ||
                  "Sin F12 Registrado"}
              </Typography>
            </Grid2>

            <Grid2 xs={12}>
              <Typography variant="subtitle2" fontWeight="bold">
                Tamaño de Paquete:
              </Typography>
              <Typography variant="body2">
                {orderDetailsCliente?.size || "No disponible"}
              </Typography>
            </Grid2>

            <Grid2 xs={12}>
              <Typography variant="subtitle2" fontWeight="bold">
                Medidas:
              </Typography>
              <Typography variant="body2">
                {`Altura: ${
                  orderDetailsCliente?.height ||
                  orderDetails.productHeight ||
                  "?"
                } | `}
                {`Peso: ${
                  orderDetailsCliente?.weight ||
                  orderDetails.productLength ||
                  "?"
                } | `}
                {`Ancho: ${
                  orderDetailsCliente?.width || orderDetails.productWidth || "?"
                }`}
              </Typography>
            </Grid2>
          </Box>
        </Grid2>
      </Box>

      <Divider sx={{ my: 1 }} />

      {/* ====== ABAJO: 2 secciones (Datos de entrega | Fotos) ====== */}
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: {
            xs: "1fr",
            md: "repeat(2, minmax(0, 1fr))", // <- columnas idénticas
          },
          gap: 3,
          alignItems: "stretch",
        }}
      >
        {/* Datos de entrega */}

        <Grid2 xs={12} md={6}>
          <Box
            sx={{
              p: 2,
              borderRadius: 2,
              border: "1px solid",
              borderColor: "divider",
              bgcolor: "background.paper",
              boxShadow: "0 1px 6px rgba(0,0,0,0.04)",
              height: "100%",
            }}
          >
            <Typography
              variant="h6"
              fontWeight={700}
              color="primary"
              gutterBottom
            >
              Datos de Entrega
            </Typography>
            <Button
              size="small"
              variant="outlined"
              startIcon={<ContentCopyIcon />}
              onClick={handleCopyDeliveryLine}
              sx={{ mb: 2 }}
            >
              Copiar datos
            </Button>

            <Snackbar
              open={copyOpen}
              autoHideDuration={2000}
              onClose={() => setCopyOpen(false)}
              anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
            >
              <Alert
                severity="success"
                variant="filled"
                onClose={() => setCopyOpen(false)}
              >
                {copyMsg}
              </Alert>
            </Snackbar>
            <Divider sx={{ mb: 2 }} />

            <Grid2 xs={12}>
              <Typography variant="subtitle2" fontWeight="bold">
                Foto tomada:
              </Typography>
              <Typography variant="body2">
                {orderDetails.picsTaken || (foto.length > 0 ? "Sí" : "No")}
              </Typography>
            </Grid2>

            <Grid2 xs={12}>
              <Typography variant="subtitle2" fontWeight="bold">
                Nombre Receptor:
              </Typography>
              <Typography variant="body2">
                {orderDetails.userNameReceptor ||
                  orderDetails.deliveryReceptor ||
                  "No disponible"}
              </Typography>
            </Grid2>

            <Grid2 xs={12}>
              <Typography variant="subtitle2" fontWeight="bold">
                RUT:
              </Typography>
              <Typography variant="body2">
                {orderDetails.userDniReceptor ||
                  orderDetails.deliveryRut ||
                  "No disponible"}
              </Typography>
            </Grid2>

            <Grid2 xs={12}>
              <Typography variant="subtitle2" fontWeight="bold">
                Última actualización:
              </Typography>
              <Typography variant="body2">{date || "No disponible"}</Typography>
            </Grid2>
          </Box>
        </Grid2>

        {/* Fotos */}
        <Grid2 xs={12} md={6}>
          <Box
            sx={{
              p: 2,
              borderRadius: 2,
              border: "1px solid",
              borderColor: "divider",
              bgcolor: "background.paper",
              boxShadow: "0 1px 6px rgba(0,0,0,0.04)",
              height: "100%",
            }}
          >
            <Typography
              variant="h6"
              fontWeight={700}
              color="primary"
              gutterBottom
            >
              Foto
            </Typography>
            <Divider sx={{ mb: 2 }} />

            {foto.length > 0 ? (
              <>
                {/* ====== Cuadrícula de miniaturas ====== */}
                <Box
                  sx={{
                    display: "grid",
                    gridTemplateColumns: {
                      xs: "repeat(2, 1fr)",
                      sm: "repeat(3, 1fr)",
                      md: "repeat(3, 1fr)",
                    },
                    gap: 1.5,
                  }}
                >
                  {foto.map((src, i) => (
                    <Box
                      key={i}
                      component="img"
                      src={src}
                      alt={`Foto ${i + 1}`}
                      sx={{
                        width: "100%",
                        height: 120,
                        objectFit: "cover",
                        borderRadius: 1.5,
                        border: "1px solid",
                        borderColor: "divider",
                        cursor: "zoom-in",
                      }}
                      onClick={() => setLightbox({ open: true, index: i })}
                    />
                  ))}
                </Box>

                {/* ====== Listado de URLs (opcional) ====== */}
                <Box sx={{ mt: 2 }}>
                  {foto.map((src, i) => (
                    <Typography
                      key={i}
                      variant="caption"
                      sx={{
                        display: "block",
                        wordBreak: "break-all",
                        opacity: 0.8,
                      }}
                    >
                      {src}
                    </Typography>
                  ))}
                </Box>

                <Dialog
                  open={lightbox.open}
                  onClose={() => setLightbox({ open: false, index: 0 })}
                  maxWidth="lg"
                  fullWidth
                  PaperProps={{ sx: { borderRadius: 2 } }}
                >
                  <DialogTitle
                    sx={{ display: "flex", alignItems: "center", gap: 1 }}
                  >
                    <Box sx={{ flex: 1 }}>
                      Foto {lightbox.index + 1} de {foto.length}
                    </Box>

                    <Tooltip title="Zoom -">
                      <span>
                        <IconButton onClick={zoomOut} disabled={zoom <= 1}>
                          <ZoomOutIcon />
                        </IconButton>
                      </span>
                    </Tooltip>
                    <Tooltip title="Zoom +">
                      <IconButton onClick={zoomIn}>
                        <ZoomInIcon />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Restablecer">
                      <IconButton onClick={resetView}>
                        <RestartAltIcon />
                      </IconButton>
                    </Tooltip>

                    <Tooltip title="Descargar">
                      <IconButton
                        component="a"
                        href={currentSrc}
                        download
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <DownloadIcon />
                      </IconButton>
                    </Tooltip>

                    <IconButton
                      onClick={() => setLightbox({ open: false, index: 0 })}
                    >
                      <CloseIcon />
                    </IconButton>
                  </DialogTitle>

                  <DialogContent
                    onWheel={onWheel}
                    onMouseDown={onMouseDown}
                    onMouseMove={onMouseMove}
                    onMouseLeave={endDrag}
                    onMouseUp={endDrag}
                    sx={{
                      position: "relative",
                      userSelect: "none",
                      cursor:
                        zoom > 1
                          ? drag.active
                            ? "grabbing"
                            : "grab"
                          : "default",
                      height: { xs: 360, sm: 480, md: 560 },
                      overflow: "hidden",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      bgcolor: "black",
                    }}
                  >
                    {/* Controles prev/next */}
                    <IconButton
                      onClick={prev}
                      sx={{
                        position: "absolute",
                        left: 8,
                        top: "50%",
                        transform: "translateY(-50%)",
                        bgcolor: "rgba(255,255,255,0.85)",
                        "&:hover": { bgcolor: "white" },
                      }}
                    >
                      <ChevronLeftIcon />
                    </IconButton>

                    <IconButton
                      onClick={next}
                      sx={{
                        position: "absolute",
                        right: 8,
                        top: "50%",
                        transform: "translateY(-50%)",
                        bgcolor: "rgba(255,255,255,0.85)",
                        "&:hover": { bgcolor: "white" },
                      }}
                    >
                      <ChevronRightIcon />
                    </IconButton>

                    {/* Imagen con zoom/pan */}
                    <Box
                      component="img"
                      src={currentSrc}
                      alt="Foto ampliada"
                      sx={{
                        maxWidth: "100%",
                        maxHeight: "100%",
                        transform: `translate(${offset.x}px, ${offset.y}px) scale(${zoom})`,
                        transition: drag.active
                          ? "none"
                          : "transform 120ms ease",
                        willChange: "transform",
                        pointerEvents: "none", // arrastre en el contenedor
                      }}
                    />
                  </DialogContent>
                </Dialog>
              </>
            ) : (
              <Typography variant="body2" color="error">
                Sin Foto
              </Typography>
            )}
          </Box>
        </Grid2>
      </Box>
    </Box>
  );

  dataContenido = (
    <Box
      sx={{
        p: 3,
        boxShadow: 2,
        borderRadius: 2,
        bgcolor: "background.paper",
        textAlign: "left",
      }}
    >
      {/* Estado */}
      <Typography variant="h6" fontWeight="bold">
        Estatus:
      </Typography>
      {orderDetailsCliente?.falabella_status && (
        <Chip
          label={translateStatesfalabbela[orderDetailsCliente.falabella_status]}
          color={getStatusColor(orderDetailsCliente.falabella_status)}
          sx={{ mt: 1, fontSize: "0.9rem", fontWeight: "bold" }}
        />
      )}

      <Divider sx={{ my: 2 }} />

      {/* Curier */}
      <Typography variant="h6" fontWeight="bold">
        Curier:
      </Typography>
      <Typography variant="body1" color="textSecondary">
        BICCI
      </Typography>

      <Divider sx={{ my: 2 }} />

      {/* Contenido */}
      <Typography variant="h6" fontWeight="bold">
        Contenido:
      </Typography>
      {dataOrdesBicciExpress?.length > 0 ? (
        <List>
          {dataOrdesBicciExpress.map((item, index) => (
            <ListItem key={index} sx={{ p: 0 }}>
              <Typography variant="body1" color="textSecondary">
                {item.PRODUCTO || item.productName} | SKU{" "}
                {item.SKU || item.productSku}
              </Typography>
            </ListItem>
          ))}
        </List>
      ) : (
        <Typography variant="body1" color="textSecondary">
          No data...
        </Typography>
      )}

      {dataOrdesBicciExpress?.length > 0 && (
        <>
          <Divider sx={{ my: 2 }} />

          {/* Código Producto */}
          <Typography variant="h6" fontWeight="bold">
            Código Producto:
          </Typography>
          <Typography variant="body1" color="textSecondary">
            {dataOrdesBicciExpress[0].SKU ||
              dataOrdesBicciExpress[0].productSku}
          </Typography>

          <Divider sx={{ my: 2 }} />

          {/* Descripción */}
          <Typography variant="h6" fontWeight="bold">
            Descripción:
          </Typography>
          <Typography variant="body1" color="textSecondary">
            {dataOrdesBicciExpress[0].PRODUCTO ||
              dataOrdesBicciExpress[0].productName}
          </Typography>

          <Divider sx={{ my: 2 }} />

          {/* Valor */}
          <Typography variant="h6" fontWeight="bold">
            Valor: $
          </Typography>
          <Typography variant="body1" color="textSecondary">
            {dataOrdesBicciExpress[0].VALOR ||
              dataOrdesBicciExpress[0].productValue}
          </Typography>
        </>
      )}

      <Divider sx={{ my: 2 }} />

      {/* Cantidad de Bultos */}
      <Typography variant="h6" fontWeight="bold">
        Cantidad de Bultos:
      </Typography>
      <Typography variant="body1" color="textSecondary">
        {orderDetailsCliente?.quantity_packages || "N/A"}
      </Typography>

      <Divider sx={{ my: 2 }} />

      {/* Cantidad de Unidades */}
      <Typography variant="h6" fontWeight="bold">
        Cantidad Unidades:
      </Typography>
      <Typography variant="body1" color="textSecondary">
        {orderDetailsCliente?.quantity || "N/A"}
      </Typography>
    </Box>
  );

  dataDriver = (
    <Box
      sx={{
        p: 3,
        boxShadow: 2,
        borderRadius: 2,
        bgcolor: "background.paper",
        display: "flex",
        flexDirection: "column",
        alignItems: "left",
        textAlign: "left",
      }}
    >
      {/* Avatar */}

      <Avatar
        src={orderDetails.driverAvatar || ""}
        alt="Foto del conductor"
        sx={{ width: 100, height: 100, mb: 2 }}
      />

      {/* ID */}
      <Typography variant="h6" fontWeight="bold">
        ID:
      </Typography>
      <Typography variant="body1" color="textSecondary">
        {orderDetails.driverID && orderDetails.driverID !== "isRequire"
          ? orderDetails.driverID
          : orderDetails.driverRut}
      </Typography>

      <Divider sx={{ my: 2 }} />

      {/* Nombre */}
      <Typography variant="h6" fontWeight="bold">
        Nombre:
      </Typography>
      <Typography variant="body1" color="textSecondary">
        {orderDetails.driverName || "No disponible"}
      </Typography>

      <Divider sx={{ my: 2 }} />

      {/* Correo */}
      {orderDetails.email && (
        <>
          <Typography variant="h6" fontWeight="bold">
            Correo Electrónico:
          </Typography>
          <Typography variant="body1" color="textSecondary">
            {orderDetails.email}
          </Typography>
          <Divider sx={{ my: 2 }} />
        </>
      )}

      {/* Teléfono */}
      <Typography variant="h6" fontWeight="bold">
        Teléfono:
      </Typography>
      {orderDetails.driverPhone ? (
        <Typography variant="body1" color="textSecondary">
          <a
            href={`tel:+56${orderDetails.driverPhone}`}
            style={{ textDecoration: "none", color: "inherit" }}
          >
            {orderDetails.driverPhone}
          </a>
        </Typography>
      ) : (
        <Typography variant="body1" color="textSecondary">
          No disponible
        </Typography>
      )}
    </Box>
  );

  actionsOrders = (
    <Box sx={{ textAlign: "left" }}>
      <Box
        fontFamily="Lato, Arial, Helvetica, sans-serif"
        color="textPrimary"
        variant="body"
      >
        Crear un registro interno de soporte, Casos de error sistema,
        incumplimentos de protocolos o reclamos del cliente.
        <TicketSupportForm
          createTicketSuport={createTicketSuport}
        ></TicketSupportForm>
      </Box>{" "}
      <hr></hr>
      <Box
        fontFamily="Lato, Arial, Helvetica, sans-serif"
        color="textPrimary"
        variant="body"
      >
        Generar maqueta email de primer intento fallido solicitud de contacto.
        <div>
          <CreateEmailClientForm
            createEmailclient={createEmailclient}
          ></CreateEmailClientForm>
        </div>
      </Box>{" "}
      <hr></hr>
      <Box
        fontFamily="Lato, Arial, Helvetica, sans-serif"
        color="textPrimary"
        variant="body"
      >
        Generar maqueta email de segundo intento fallido solicitud de contacto.
        <div>
          <CreateEmailSecondAttemptForm
            createEmailclient={createEmailclient}
          ></CreateEmailSecondAttemptForm>
        </div>
      </Box>
      <hr></hr>
      <Box
        fontFamily="Lato, Arial, Helvetica, sans-serif"
        color="textPrimary"
        variant="body"
      >
        Generar maqueta email de tercer intento fallido solicitud de contacto.
        <div>
          <CreateEmailThirdAttemptForm
            createEmailclient={createEmailclient}
          ></CreateEmailThirdAttemptForm>
        </div>
      </Box>
      <hr></hr>
      <Box
        fontFamily="Lato, Arial, Helvetica, sans-serif"
        color="textPrimary"
        variant="body"
      >
        Generar maqueta email de confirmación de dirección destino - Paquetes
        con dirección no legible.
        <div>
          <CreateEmailConfirmationForm
            createEmailclient={createEmailclient}
          ></CreateEmailConfirmationForm>
        </div>
      </Box>{" "}
      <hr></hr>
      <Box
        fontFamily="Lato, Arial, Helvetica, sans-serif"
        color="textPrimary"
        variant="body"
      >
        Generar Autorización de cambio de domicilio.
        <div>
          <CreateEmailAuthorizationForm
            createEmailclient={createEmailclient}
          ></CreateEmailAuthorizationForm>
        </div>
      </Box>{" "}
      <hr></hr>
      {!orderDetails.int_falabella_status ? (
        <Box
          fontFamily="Lato, Arial, Helvetica, sans-serif"
          color="textPrimary"
          variant="body"
        >
          Editar dirección con error.
          <div>Dirección actual:</div>
          <div>{orderDetails.toAddress}</div>
          <AddNewAddressForm
            setOrderDetails={setOrderDetails}
            orderDetails={orderDetails}
            usuarioStorage={usuarioStorage}
            registrarCambioEnOrden={registrarCambioEnOrden}
            dispatch={dispatch}
            collectionRef={collectionRef}
          ></AddNewAddressForm>
        </Box>
      ) : null}
      <hr></hr>
      {bloqueaGoogle !== true ? (
        <AdjustGeoReferenceForm
          orderDetails={orderDetails}
          addNewGeoPoint={addNewGeoPoint}
        ></AdjustGeoReferenceForm>
      ) : null}
      <hr></hr>
    </Box>
  );

  logDeCambios = (
    <Box sx={{ textAlign: "left" }}>
      {storePayload && storePayload.upload === true ? (
        <>
          {storePayload.logs.map((item, index) => (
            <Card
              key={index}
              sx={{ margin: "3px", padding: "3px" }}
              variant="outlined"
            >
              <div>{format(item.date.seconds * 1000, "dd/MM/yy HH:mm:ss")}</div>
              <div>Usuario </div>
              <div>{item.userId}</div>
              <div>Accion: {item.var}</div>
              <div>
                {typeof item.lastValue === "object" &&
                item.lastValue !== null ? (
                  <>Geopunto</>
                ) : (
                  <>
                    {" "}
                    <div>valor anterior: {item.lastValue} </div>
                    <div>nuevo valor {item.newValue}</div>
                  </>
                )}
              </div>
            </Card>
          ))}
        </>
      ) : (
        <>Sin cambios</>
      )}
    </Box>
  );

  return (
    <Box sx={{ width: "100%" }}>
      {/* Contenedor de Tabs */}
      <Tabs
        value={activeTab}
        onChange={handleChange}
        variant="fullWidth"
        textColor="primary"
        indicatorColor="primary"
      >
        {panes.map((pane, index) => (
          <Tab key={index} label={pane.label} />
        ))}
      </Tabs>

      {/* Contenido de cada pestaña */}
      {panes.map((pane, index) => (
        <TabPanel key={index} value={activeTab} index={index}>
          <Box>{pane.content}</Box>
        </TabPanel>
      ))}
    </Box>
  );
};

// Componente auxiliar para mostrar el contenido de cada pestaña
const TabPanel = ({ children, value, index }) => {
  return (
    <Box
      role="tabpanel"
      hidden={value !== index}
      sx={{
        p: 0,
        display: value === index ? "block" : "none",
        height: "70vh",
        overflowY: "scroll",
      }}
    >
      <Card sx={{ p: 0, boxShadow: 2 }}>
        <CardContent>
          <Box>{children}</Box>
        </CardContent>
      </Card>
    </Box>
  );
};

export default TabSecondary;
